<template>
  <div class="m-page">
    <div class="m-info-box">
      <div class="m-info-tit"><img src="@/assets/img/home/payIco.png" alt=""><span>支付信息</span></div>
      <div v-if="obj&&obj.outOrderNo" class="m-nav"><span>订单编号</span><p>{{obj.outOrderNo}}</p></div>
      <div v-if="obj&&obj.paymentType" class="m-nav"><span>支付方式</span><p>{{obj.paymentType==1 ? '微信' : obj.paymentType==2 ? '支付宝' : '后台缴费'}}</p></div>
      <div v-if="obj&&obj.paymentAmount" class="m-nav"><span>支付金额</span><p>{{obj.paymentAmount ? obj.paymentAmount:''}}元</p></div>
      <div v-if="obj&&obj.paymentTime" class="m-nav"><span>支付时间</span><p>{{obj.paymentTime}}</p></div>
    </div>
  </div>
</template>

<script>

  export default {
    components: {},
    props:{
      obj:{
        type:Object,
        default: () => {}
      }
    },
    data () {
      return {
        payRecordPO: {}
      }
    },
    created () {

    },
    methods: {},
    mounted () {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  .m-page{
    .m-info-box{
      background: #ffffff;
      border-radius: 4px;
      padding: 15px 12px 0 12px;
      margin-top: 18px;
      .m-info-tit{
        display: flex;
        align-items: center;
        padding-bottom: 15px;
        >img{
          width: 16px;
          height: 16px;
        }
        >span{
          color: #2B6CF9;
          font-weight: bold;
          margin-left: 3px;
        }
      }
      .m-nav{
        padding-bottom: 20px;
        display: flex;
        >span{
          display: inline-block;
          width: 90px;
          color: #8D8F93;
        }
        >p{
          flex: 1;
          text-align: right;
        }
      }
    }
  }

</style>

